var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"page-section-content",style:(_vm.styles)},[_c('GeneralContent',_vm._b({},'GeneralContent',_vm.content,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }